module.exports = __webpack_public_path__ + "img/考试需求@2x.e64ca246.png";